import { Formik, Form } from 'formik';
import { FIELD_TYPE_POSTAL, STEP_USER_DATA, STEP_CALCULATION, FIELD_TYPE_ADDRESS, FIELD_TYPE_NUMERICAL, FIELD_TYPE_CHOICE } from '../../utils/CONSTANTS.js';
import { WizardContext, ApiContext } from '../../utils/contexts.js';
import analyticsTrack from '../../utils/tracking.js';
import { each } from 'lodash-es';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import * as Yup from 'yup';
import { isIframe } from '../../utils/isEnv.js';
import { getLine, getNextButtonText, getSpinnerDuration } from '../../services/models/dialog.js';
import Step from './Step.js';
import { jsx } from '@emotion/react';
var buildInitialValues = function buildInitialValues(lineObject) {
  var initialValues = {};
  each(lineObject.steps, function (step, key) {
    // As address is an implicit "flat object" with well-defined shape we need to create each field manually.
    if ((step === null || step === void 0 ? void 0 : step.type) === FIELD_TYPE_ADDRESS) {
      initialValues["".concat(key, "_street")] = '';
      initialValues["".concat(key, "_zip")] = '';
      initialValues["".concat(key, "_city")] = '';
    } else {
      initialValues[key] = '';
    }
  });
  return initialValues;
};

/**
 * Builds the validation schema based on the line object
 * @param lineObject
 */
var buildValidationSchema = function buildValidationSchema(lineObject) {
  var validationSchema = {};
  each(lineObject.steps, function (step, key) {
    switch (step.type) {
      case FIELD_TYPE_CHOICE:
        {
          var choiceSchema = Yup.string();
          if (step.options.mandatory) {
            choiceSchema = choiceSchema.required('Bitte treffen Sie eine Auswahl.');
          }
          validationSchema[key] = choiceSchema;
          break;
        }
      case FIELD_TYPE_ADDRESS:
        {
          var streetSchema = Yup.string();
          var zipSchema = Yup.string();
          var citySchema = Yup.string();
          if (step.options.mandatory) {
            streetSchema = streetSchema.required('Bitte geben Sie eine Straße und Hausnummer an.');
            zipSchema = zipSchema.required('Bitte geben Sie eine PLZ an.');
            citySchema = citySchema.required('Bitte geben Sie einen Ort an.');
          }
          validationSchema["".concat(key, "_street")] = streetSchema;
          validationSchema["".concat(key, "_zip")] = zipSchema;
          validationSchema["".concat(key, "_city")] = citySchema;
          break;
        }
      case FIELD_TYPE_POSTAL:
        {
          var postalSchema = Yup.string();
          if (step.options.mandatory) {
            postalSchema = postalSchema.required('Bitte geben Sie eine PLZ an.');
          }
          validationSchema[key] = postalSchema;
          break;
        }
      case FIELD_TYPE_NUMERICAL:
        {
          var numberSchema = Yup.number();
          if (step.options.mandatory) {
            numberSchema = numberSchema.required('Bitte geben Sie eine Zahl an.');
          }
          if (step.options.min) {
            numberSchema = numberSchema.min(step.options.min, "Die Zahl darf nicht kleiner als ".concat(step.options.min, " sein."));
          }
          if (step.options.max) {
            numberSchema = numberSchema.max(step.options.max, "Die Zahl darf nicht gr\xF6\xDFer als ".concat(step.options.max, " sein."));
          }
          validationSchema[key] = numberSchema;
          break;
        }
      case 'slider':
        {
          var sliderSchema = Yup.number();
          if (step.options.mandatory) {
            sliderSchema = sliderSchema.required('Bitte geben Sie eine Zahl an.');
          }
          validationSchema[key] = sliderSchema;
          break;
        }
      default:
        validationSchema[key] = Yup.mixed();
    }
  });
  return Yup.object().shape(validationSchema);
};
var Dialog = function Dialog(_ref) {
  var lineKey = _ref.lineKey;
  var _useContext = useContext(WizardContext),
    setCurrentStep = _useContext.setCurrentStep,
    currentLine = _useContext.currentLine,
    setStepData = _useContext.setStepData,
    currentStep = _useContext.currentStep,
    dialogId = _useContext.dialogId,
    leadId = _useContext.leadId,
    recruiterId = _useContext.recruiterId;
  var _useContext2 = useContext(ApiContext),
    data = _useContext2.data;
  return jsx(Formik, {
    initialValues: buildInitialValues(getLine(data, currentLine)),
    validationSchema: buildValidationSchema(getLine(data, currentLine)),
    handleChange: true,
    validateOnMount: true,
    onSubmit: function onSubmit(values) {
      setStepData(values);

      // Send a post message to our embedding host, when we have a postal
      // code filed which was filled by the user
      var postalStep = Object.entries(getLine(data, currentLine).steps).find(function (cur) {
        return cur[1].type === FIELD_TYPE_POSTAL;
      });
      if (isIframe && postalStep) {
        var postalStepName = postalStep[0];
        var postalValue = values[postalStepName];
        if (postalValue) {
          window.parent.postMessage({
            type: 'postal_code_entered',
            target: '#hausgold-wizard',
            postalCode: postalValue
          }, '*');
        }
      }

      // Track user progress (last Step; Next is CALCULATION_STEP / "Kontaktformular").
      analyticsTrack({
        event: 'Formwizard Interacted',
        params: {
          dialog_id: dialogId,
          lead_id: leadId,
          recruiter_id: recruiterId,
          label: getNextButtonText(data)
        }
      });
      if (getSpinnerDuration(data) === 0) {
        setCurrentStep(STEP_USER_DATA);
      } else {
        setCurrentStep(STEP_CALCULATION);
      }
    }
  }, jsx(Form, null, jsx(Step, {
    stepKey: currentStep,
    lineKey: lineKey
  })));
};
Dialog.propTypes = {
  lineKey: PropTypes.string
};
Dialog.defaultProps = {
  lineKey: ''
};
export { Dialog as default };